"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

// Tax numbers of Novivia
// AE_TAX_NUMBERS
exports.default = {
  gst: "828438978 RT 0001",
  qst: "1221254666 TQ 0001"
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/configurations/lib/common/AE_TAX_NUMBERS.js
// module id = 72
// module chunks = 9 10 11 12 13 14 15 18 19 20 21 22 23 24 25 26 27 28 29 30 33 34 35 38 39 40 41 42 43 45 46 47 48 49 50 51 54